/**
 * URL guards for authored content. Authors are trusted staff, but authored URLs still
 * render inside the participant app — never emit javascript:/data: links or iframes.
 */
export const safeHref = (url?: string): string | undefined => {
  const trimmed = (url ?? "").trim();
  // tel:/mailto: are legitimate for icon links (call the study team, email support)
  if (/^(https:\/\/|mailto:|tel:)/i.test(trimmed)) return trimmed;
  return undefined;
};

/** Iframes are stricter: https only. */
export const safeIframeSrc = (url?: string): string | undefined => {
  const trimmed = (url ?? "").trim();
  return /^https:\/\//i.test(trimmed) ? trimmed : undefined;
};
